import React, { useState } from 'react';
import { FaPlay, FaYoutube, FaImage, FaVideo } from 'react-icons/fa';
import transformPhoto from '../assets/transform.png';

const Gallery = ({ YOUTUBE_CHANNEL }) => {
  const [activeTab, setActiveTab] = useState('transformations');

  const transformations = [
    {
      id: 1,
      name: 'Rajesh - Weight Loss Journey',
      before: transformPhoto,
      after: transformPhoto,
      duration: '6 months',
      weightLost: '20kg',
      description: 'From 95kg to 75kg through consistent training and nutrition'
    },
    {
      id: 2,
      name: 'Priya - Muscle Gain',
      before: transformPhoto,
      after: transformPhoto,
      duration: '4 months',
      weightLost: '+6kg',
      description: 'Built lean muscle and strength with progressive overload'
    },
    {
      id: 3,
      name: 'Arun - Body Recomposition',
      before: transformPhoto,
      after: transformPhoto,
      duration: '8 months',
      weightLost: '15kg',
      description: 'Lost fat and gained muscle simultaneously'
    },
    {
      id: 4,
      name: 'Meera - Fat Loss',
      before: transformPhoto,
      after: transformPhoto,
      duration: '5 months',
      weightLost: '12kg',
      description: 'HIIT training and nutrition planning for amazing results'
    }
  ];

  const videos = [
    {
      id: 1,
      title: '10-Min Morning Fat Burn Workout',
      thumbnail: transformPhoto,
      duration: '10:24',
      views: '15K',
      category: 'Fat Loss'
    },
    {
      id: 2,
      title: 'Full Body Strength Training',
      thumbnail: transformPhoto,
      duration: '25:15',
      views: '22K',
      category: 'Strength'
    },
    {
      id: 3,
      title: 'HIIT Cardio Blast',
      thumbnail: transformPhoto,
      duration: '20:00',
      views: '18K',
      category: 'Cardio'
    },
    {
      id: 4,
      title: 'Muscle Building Workout',
      thumbnail: transformPhoto,
      duration: '30:45',
      views: '25K',
      category: 'Muscle Gain'
    },
    {
      id: 5,
      title: 'Core Crusher Abs Workout',
      thumbnail: transformPhoto,
      duration: '15:20',
      views: '20K',
      category: 'Core'
    },
    {
      id: 6,
      title: 'Upper Body Power Training',
      thumbnail: transformPhoto,
      duration: '28:30',
      views: '19K',
      category: 'Strength'
    }
  ];

  return (
    <div className="min-h-screen bg-black py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-8 sm:mb-12">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-yellow-400 uppercase tracking-wide mb-3 sm:mb-4">
            Transformation Gallery
          </h1>
          <p className="text-gray-400 text-base sm:text-lg">
            Real results from real people
          </p>
        </div>

        {/* Tabs */}
        <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4 mb-8 sm:mb-12">
          <button
            onClick={() => setActiveTab('transformations')}
            className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-bold uppercase text-sm tracking-wide transition-all transform hover:scale-105 border-2 ${
              activeTab === 'transformations'
                ? 'bg-gradient-to-r from-yellow-500 to-orange-600 text-black border-yellow-400'
                : 'bg-gray-900 text-gray-300 hover:text-yellow-400 border-gray-700'
            }`}
          >
            <FaImage />
            <span>Before/After</span>
          </button>
          <button
            onClick={() => setActiveTab('videos')}
            className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-bold uppercase text-sm tracking-wide transition-all transform hover:scale-105 border-2 ${
              activeTab === 'videos'
                ? 'bg-gradient-to-r from-yellow-500 to-orange-600 text-black border-yellow-400'
                : 'bg-gray-900 text-gray-300 hover:text-yellow-400 border-gray-700'
            }`}
          >
            <FaVideo />
            <span>Workout Videos</span>
          </button>
        </div>

        {/* Transformations Tab */}
        {activeTab === 'transformations' && (
          <div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
              {transformations.map((transformation) => (
                <div
                  key={transformation.id}
                  className="bg-gray-900 border-2 border-yellow-500/30 rounded-xl overflow-hidden hover:border-yellow-400 transition-all"
                >
                  {/* Before/After Images */}
                  <div className="grid grid-cols-2 gap-1">
                    <div className="relative">
                      <img
                        src={transformation.before}
                        alt="Before"
                        className="w-full h-64 object-cover"
                      />
                      <div className="absolute top-4 left-4 bg-red-600 text-white px-3 py-1 rounded-lg font-bold text-sm uppercase">
                        Before
                      </div>
                    </div>
                    <div className="relative">
                      <img
                        src={transformation.after}
                        alt="After"
                        className="w-full h-64 object-cover"
                      />
                      <div className="absolute top-4 right-4 bg-green-600 text-white px-3 py-1 rounded-lg font-bold text-sm uppercase">
                        After
                      </div>
                    </div>
                  </div>

                  {/* Info */}
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-yellow-400 uppercase mb-3">
                      {transformation.name}
                    </h3>
                    <p className="text-gray-400 text-sm mb-4">
                      {transformation.description}
                    </p>
                    <div className="grid grid-cols-2 gap-4">
                      <div className="bg-black border border-gray-700 rounded-lg p-3 text-center">
                        <div className="text-xs text-gray-500 uppercase mb-1">Duration</div>
                        <div className="text-lg font-bold text-orange-400">{transformation.duration}</div>
                      </div>
                      <div className="bg-black border border-gray-700 rounded-lg p-3 text-center">
                        <div className="text-xs text-gray-500 uppercase mb-1">Result</div>
                        <div className="text-lg font-bold text-green-400">{transformation.weightLost}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="mt-8 sm:mt-12 bg-gradient-to-r from-yellow-500 via-orange-500 to-red-600 rounded-2xl p-6 sm:p-8 text-center">
              <h2 className="text-2xl sm:text-3xl font-bold text-black uppercase tracking-wide mb-3 sm:mb-4">
                Your Transformation Starts Here
              </h2>
              <p className="text-gray-900 text-base sm:text-lg mb-4 sm:mb-6">
                These results are achievable with dedication and proper guidance
              </p>
              <button className="bg-black hover:bg-gray-900 text-yellow-400 px-8 py-4 rounded-lg font-bold uppercase tracking-wide transition-all transform hover:scale-105 border-2 border-black">
                Start Your Journey
              </button>
            </div>
          </div>
        )}

        {/* Videos Tab */}
        {activeTab === 'videos' && (
          <div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {videos.map((video) => (
                <div
                  key={video.id}
                  className="bg-gray-900 border-2 border-orange-500/30 rounded-xl overflow-hidden hover:border-orange-400 transition-all transform hover:scale-105 cursor-pointer group"
                >
                  {/* Thumbnail */}
                  <div className="relative">
                    <img
                      src={video.thumbnail}
                      alt={video.title}
                      className="w-full h-48 object-cover"
                    />
                    <div className="absolute inset-0 bg-black/50 flex items-center justify-center group-hover:bg-black/30 transition-all">
                      <div className="bg-red-600 p-4 rounded-full group-hover:scale-110 transition-all">
                        <FaPlay className="text-white text-2xl ml-1" />
                      </div>
                    </div>
                    <div className="absolute top-4 right-4 bg-black/80 text-white px-2 py-1 rounded text-xs font-bold">
                      {video.duration}
                    </div>
                    <div className="absolute top-4 left-4 bg-orange-600 text-white px-2 py-1 rounded text-xs font-bold uppercase">
                      {video.category}
                    </div>
                  </div>

                  {/* Info */}
                  <div className="p-4">
                    <h3 className="text-lg font-bold text-white mb-2 line-clamp-2">
                      {video.title}
                    </h3>
                    <div className="flex items-center justify-between text-sm text-gray-400">
                      <span>👁️ {video.views} views</span>
                      <a
                        href={YOUTUBE_CHANNEL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-red-400 hover:text-red-300 font-semibold flex items-center space-x-1"
                      >
                        <FaYoutube />
                        <span>Watch</span>
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* YouTube CTA */}
            <div className="mt-12 bg-gradient-to-r from-red-600 to-red-800 rounded-2xl p-8 text-center border-4 border-red-500/50">
              <div className="flex justify-center mb-4">
                <div className="bg-white p-4 rounded-full">
                  <FaYoutube className="text-red-600 text-4xl" />
                </div>
              </div>
              <h2 className="text-3xl font-bold text-white uppercase tracking-wide mb-4">
                80+ Workout Videos Available
              </h2>
              <p className="text-red-100 text-lg mb-6">
                Subscribe to my YouTube channel for free workout videos, fitness tips, and motivation
              </p>
              <a
                href={YOUTUBE_CHANNEL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 bg-white text-red-600 px-8 py-4 rounded-lg font-bold uppercase tracking-wide transition-all transform hover:scale-105 border-2 border-white"
              >
                <FaYoutube size={24} />
                <span>Subscribe Now</span>
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Gallery;
